import React from 'react';
import {
  ImageSourcePropType,
  ImageStyle,
  Platform,
  StyleProp,
  StyleSheet,
  View,
} from 'react-native';
import SecureImage from '../Reusables/SecureImage';
import { ONBOARDING_SLIDES } from '../../constants/onboarding';
import { s, v } from '../../utils/libs';

type OnboardingSlideImageProps = {
  source?: ImageSourcePropType;
  style?: StyleProp<ImageStyle>;
};

/** A slide's image. The carousel and the warm-up must decode at the same size. */
export const OnboardingSlideImage: React.FC<OnboardingSlideImageProps> = ({
  source,
  style,
}) => (
  <SecureImage
    source={source}
    style={[styles.image, style]}
    resizeMode="contain"
  />
);

/**
 * Decodes the slides invisibly so the carousel paints them on its first frame.
 * Android's image cache is keyed by display size, so `FastImage.preload` (which
 * caches full size) would still leave the carousel decoding on arrival.
 */
export const OnboardingSlidesWarmup: React.FC = () => (
  <View pointerEvents="none" aria-hidden style={styles.warmup}>
    {ONBOARDING_SLIDES.map(slide => (
      <OnboardingSlideImage
        key={slide.id}
        source={slide.image}
        style={styles.warmupImage}
      />
    ))}
  </View>
);

const styles = StyleSheet.create({
  image: {
    width: s(Platform.OS === 'web' ? 400 : 340),
    height: v(Platform.OS === 'web' ? 380 : 320),
  },
  warmup: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0,
  },
  warmupImage: {
    position: 'absolute',
  },
});
